<div class="ctm-tab custom-card">
        <div class="modal-header">
          <h4 class="modal-title" id="modal-basic-title" translate>
                lblCustomerSelection
          </h4>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="OnClose()"
            aria-label="Center Align"
          >
            <span aria-hidden="true"> × </span>
          </button>
        </div>
      
        <div class="modal-body p-0">
          <div class="card pad15 pb-0 card-body-p0">
            <ngb-accordion #a="ngbAccordion" [activeIds]="activePanel">    
              <ngb-panel id="second">
                <ng-template ngbPanelHeader class="custom-header ctm">
                  <div class="d-flex align-items-center">
                    <button
                      ngbPanelToggle
                      translate
                      class="btn d-flex w-100 align-items-center text-left"
                      aria-label="Center Align"
                    >
                      lblCustomerList
                      <ng-container
                      ><em class="fas fa-angle-down fa-lg ml-auto"></em>
                    </ng-container>
                    </button>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <table>
                    <thead>
                      <tr>
                        <th style="width: 10%" scope="col" translate>lblSelect</th>
                        <th style="width: 12%" scope="col" translate>lblCustomer</th>
                        <th style="width: 12%" scope="col" translate>lblMobile</th>
                        <th style="width: 12%" scope="col" class="text-center" translate>lblIsCompany</th>
                        <th style="width: 17%" scope="col" translate>lblAddress</th>
                        <th style="width: 11%" scope="col" translate>lblCity</th>
                        <th style="width: 11%" scope="col" translate>lblCountry</th>
                        <th style="width: 10%" scope="col" translate>lblPostcode</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngIf="customerList?.length > 0; else load_else">
                        <ng-container
                          *ngFor="let cust of customerList; let i = index"
                        >
                          <tr>
                            <td>
                              <input
                                name="select"
                                type="radio"
                                class="radio-custom"
                                [value]="cust.isSelected"
                                (change)="onCustomerSelect(i)"
                              />
                            </td>
                            <td>
                              <ngb-highlight [result]="cust.customerName"
                                >{{ cust.customerName }}
                              </ngb-highlight>
                            </td>
                            <td>
                              <ngb-highlight [result]="cust.mobileNo"
                                >{{ cust.mobileNo }}
                              </ngb-highlight>
                            </td>
                            <td class="text-center">
                              <span *ngIf="(cust.customerTypeId == 2)">
                                <em class="fas fa-check"></em>
                              </span>
                                
                            </td>
                            <td>
                              <ngb-highlight [result]="cust.addressLine1"
                                >{{ cust.addressLine1 }}
                              </ngb-highlight>
                            </td>
                            <td>
                              <ngb-highlight [result]="cust.city"
                                >{{ cust.city }}
                              </ngb-highlight>
                            </td>
                            <td>
                              <ngb-highlight [result]="cust.country">
                                {{ cust.country }}
                              </ngb-highlight>
                            </td>
                            <td>
                              <ngb-highlight [result]="cust.pincode"
                                >{{ cust.pincode }}
                              </ngb-highlight>
                            </td>
                          </tr>
                        </ng-container>
                      </ng-container>
                      <ng-template #load_else>
                        <tr>
                          <td colspan="12" class="no-record" translate>
                            lblNoRecordsFound
                          </td>
                        </tr>
                      </ng-template>
                    </tbody>
                  </table>
                  <div class="card-footer">
                    <div class="d-flex justify-content-between">
                      <app-pagination
                        [pager]="pager"
                        [recordSize]="totalCount"
                        (setPageEvent)="setPage($event)"
                      >
                      </app-pagination>
                      <div
                        class="d-flex align-items-center justify-content-between font17 fontbold"
                      >
                        <span class="font17 fontnormal" translate>lblTotal</span
                        >:&nbsp;{{ totalCount }}&nbsp;<span
                          class="font17 fontnormal"
                          translate
                          >lblResults</span
                        >
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </div>
        </div>
        <div class="p-3 bg-light">

          <div class="d-flex flex-sm-row flex-column justify-content-end">
                <button
                class="btn btn-primary mr-sm-2 btn-lg"
                (click)="onSelect()"
                translate
                [disabled]="!isSelectActive"
                aria-label="Center Align"
              >
              <em class="fas fa-object-ungroup font16 align-top mr-2"></em>
                lblSelect
              </button>
            <a
              (click)="OnClose()"
              type="reset"
              class="btn btn-secondary btn-lg"
              translate
              ><em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a
            >
          </div>
        </div>
      </div>
      
